import * as React from "react";

import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "~/lib/utils";

type SwitchVariant = "default" | "terra";

const switchCheckedBackgroundByVariant: Record<SwitchVariant, string> = {
    default: "data-[state=checked]:bg-brand-forest-800",
    terra: "data-[state=checked]:bg-brand-terra-600",
};

type SwitchProps = React.ComponentPropsWithoutRef<
    typeof SwitchPrimitives.Root
> & {
    variant?: SwitchVariant;
};

// AIDEV-NOTE: Design system spec — Toggle is 38×22 track with a 16px white
// thumb. Default ON = forest-800. Terra variant is for dark forest onboarding.
const Switch = React.forwardRef<
    React.ElementRef<typeof SwitchPrimitives.Root>,
    SwitchProps
>(({ className, variant = "default", ...props }, ref) => (
    <SwitchPrimitives.Root
        className={cn(
            "peer inline-flex h-[22px] w-[38px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_rgba(27,67,50,0.12)] disabled:cursor-not-allowed disabled:opacity-50 data-[state=unchecked]:bg-gray-300",
            switchCheckedBackgroundByVariant[variant],
            className,
        )}
        {...props}
        ref={ref}
    >
        <SwitchPrimitives.Thumb
            className={cn(
                "pointer-events-none block h-4 w-4 rounded-full bg-white shadow-sm ring-0 transition-transform data-[state=checked]:translate-x-[16px] data-[state=unchecked]:translate-x-0",
            )}
        />
    </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
